var _mask, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 10,
    maskUnits: "userSpaceOnUse",
    width: 10,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v10H0z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4h-5a.5.5 0 00-.5.5V9H9.5a.5.5 0 00-.5.5V14H4.5a.5.5 0 00-.5.5v5a.5.5 0 001 0V15h4.5a.5.5 0 00.5-.5V10h4.5a.5.5 0 00.5-.5V5h4.5a.5.5 0 000-1",
    fill: "#12100b",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5a.5.5 0 001 0v-4a.43.43 0 000-.19.51.51 0 00-.31-.31.41.41 0 00-.19 0h-4a.5.5 0 00-.5.5.5.5 0 00.5.5h2.79L.15 9.15a.48.48 0 000 .7.47.47 0 00.35.15.47.47 0 00.35-.15L9 1.71z",
    fill: "#12100b",
    fillRule: "evenodd"
  }))));
}

SvgUpgrade.displayName = 'Upgrade';
export default SvgUpgrade;